import machineDefaultImage from '../../../images/machineImageEmpty.svg';
import { typedDocumentsImageUrl } from '../../../utils/imageProxy';
import { Box, Typography, Grid } from '@mui/material';
import '../../../css/machines/localisationEtStatut.css';

const RiskBox = ({ image, title }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3px', mb: 2 }}>
            <img src={image} alt="icon" style={{ width: '45px', height: '45px', borderRadius: '2px', objectFit: 'cover' }} loading='lazy' decoding='async' />
            <Typography className='modeEtConseigne_text_response'>{title}</Typography>
        </Box>
    );
};

const PublicMachineRisk = ({ risk_machine }) => {

    if (!risk_machine?.length) {
        return null;
    }

    return (
        <Box className='localisationEtStatut_box'>
            <Box className='localisation_edit_box'>
                <Typography className='localisationEtStatut_title'>Risques</Typography>
            </Box>
            <Box className='localisationEtStatut_icon_title_response_box'>
                <Grid container spacing={4}>
                    {risk_machine.map((r) => {
                        const img = typedDocumentsImageUrl(r?.risk?.risk_document, { size: 'picto', fallback: machineDefaultImage });
                        return (
                            <Grid key={r?.id} item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <RiskBox
                                    image={img}
                                    title={r?.risk?.name}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        </Box>
    );
};

export default PublicMachineRisk;
